<label
  class="inline-flex items-center gap-2 cursor-pointer group border border-blue-deep rounded-xl p-3 hover:bg-blue-light/10 transition-colors"
>
  <input
    type="checkbox"
    [checked]="checked"
    (change)="onCheckboxChange($event)"
    class="w-checkbox h-checkbox cursor-pointer accent-blue-300 border border-blue-deep rounded"
  />
  <span class="text-base text-text-primary group-hover:text-blue-300">
    {{ label }}
  </span>
</label>
